import {Component} from '@angular/core';
import {ViewManagerService} from "../../../services/view-manager.service";

@Component({
  selector: '[admin-msg-banner]',
  templateUrl: './msg-banner.component.html',
  styleUrls: ['./msg-banner.component.css']
})
export class MsgBannerComponent {

  constructor(private viewManager: ViewManagerService) {
  }

  messages() {
    return this.viewManager.messages
  }
}
